import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

interface PageProps {
  data: {
    page: {
      title?: string
      databaseId?: number
      path?: string
      seo: any
      flexContent: any
      projectdetail?: any
    }
  }
  location?: any
}

export const ProjectContext = React.createContext({})

const PageTemplate: React.FC<PageProps> = ({
  data: {
    page: { databaseId, projectdetail, flexContent, seo },
  },
  location = {},
}) => (
  <Layout>
    <SEO seo={seo} />
    <ProjectContext.Provider value={{ details: projectdetail, id: databaseId }}>
      <FlexContentHandler
        prefix="Project_Flexcontent"
        fields={flexContent}
        location={location}
      />
    </ProjectContext.Provider>
  </Layout>
)

export const pageQuery = graphql`
  query projectById($id: String!) {
    page: wpProject(id: { eq: $id }) {
      ...generalProjectFragment
    }
  }
`

export default PageTemplate
